// extracted by mini-css-extract-plugin
module.exports = {"statisticsSection":"InfoBox_statisticsSection__3veaT","skewedBorder":"InfoBox_skewedBorder__8n6k_"};